export default "__VITE_ASSET__c0427915__"